import React, { useState } from 'react';
import ComicForm from './components/ComicForm';
import ComicDisplay from './components/ComicDisplay';
import { query } from './components/api';
import './App.css'; 

const App = () => {
  const [comicImages, setComicImages] = useState([]);
  const [loading, setLoading] = useState(false);

  const generateComic = async (textInputs) => {
    try {
      setLoading(true);

      const imagePromises = textInputs.map(async (textInput) => {
        // Use the provided API integration to get text-to-image for each panel
        const imageBlob = await query({ inputs: textInput });
        return URL.createObjectURL(imageBlob);
      });

      // Wait for all image promises to resolve
      const images = await Promise.all(imagePromises);

      // Set the array of image URLs in state
      setComicImages(images);
    } catch (error) {
      console.error("Error generating comic:", error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <h1>Comic Generator</h1>
      <ComicForm generateComic={generateComic} />
      
      {loading ? (
        <p className="loading">Generating comic, please wait...</p>
      ) : (
        <ComicDisplay images={comicImages} />
      )}
    </div>
  );
};

export default App;